import React from "react";
import { render } from "react-dom";

import CampaignCard from "components/CampaignCard";
import CampaignListing from "components/CampaignListing";
import dataScroll from "helpers/dataScroll";

import "./style.scss";

if (document.getElementById("js-search-results") !== null) {
  render(
    <CampaignListing>
      {window.Chuffed.campaigns.map((campaign, index) => (
        <CampaignCard key={index} campaign={campaign} />
      ))}
    </CampaignListing>,
    document.getElementById("js-search-results"),
  );
}

dataScroll();
